<template>
	<header :class="['header', { 'kbprm-header': isKbPrmHost }]">
		<div class="cont_center">
			<!-- 기본 .logo + 은행별 변형 클래스 동시 적용 -->
			<div :class="['logo', logoClass]">
				<a href="/" class="logo-link">{{ siteHeading }}</a>
			</div>

			<ul class="top_menu" v-if="isLoggedIn">
				<li class="mypage">
					<a href="/HFO_MP_005">내정보</a>
				</li>
				<li><a href="#" @click="logout">로그아웃</a></li>
			</ul>
			<ul class="top_menu" v-else-if="!isKbPrmHost">
				<li class="login">
					<a href="/HFO_LO_001" @click.prevent="openLoginPopup('login')">로그인</a>
				</li>
			</ul>

			<ul class="m_gnb_list">
				<li class="gnb1">
					<a :href="brandPagePath" @click="handleBrandLinkClick">제휴브랜드</a>
				</li>
				<li class="gnb2">
					<a href="/HFO_MS_001">매장검색</a>
				</li>
				<li class="gnb3" v-if="!isKbPrmHost">
					<a href="/HFO_PR_001">프로모션</a>
				</li>
				<li class="gnb4" v-if="!isKbPrmHost">
					<a href="/HFO_SP_001">쇼핑</a>
				</li>
				<li class="gnb_coupon" v-if="false">
					<a href="/HFO_CP_001">쿠폰</a>
				</li>
			</ul>

			<div class="menu_layout">
				<div class="menu_area">
					<ul class="gnb_list">
						<li class="gnb1">
							<a :href="brandPagePath" @click="handleBrandLinkClick">제휴브랜드</a>
						</li>
						<li class="gnb2">
							<a href="/HFO_MS_001">매장검색</a>
						</li>
						<li class="gnb3" v-if="!isKbPrmHost">
							<a href="/HFO_PR_001">프로모션</a>
						</li>
						<li class="gnb4" v-if="!isKbPrmHost">
							<a href="/HFO_SP_001">쇼핑</a>
						</li>
						<li class="gnb_coupon" v-if="false">
							<a href="/HFO_CP_001">쿠폰</a>
						</li>
					</ul>

					<div class="gnb_list2_area">
						<ul class="gnb_list2">
							<li class="gnb5">
								<a href="/HFO_CS_001">공지사항</a>
							</li>
							<li class="gnb6">
								<a href="/HFO_CS_004">1:1 문의</a>
							</li>
							<li class="gnb7" v-if="!isKbPrmHost">
								<a href="/HFO_CS_003">자주하는 질문</a>
							</li>
							<li class="gnb8" v-if="!isKbPrmHost">
								<a href="/HFO_BI_003">제휴문의</a>
							</li>
						</ul>

						<!-- 로그인 상태에 따른 메뉴 표시 - 로그인한 경우 -->
						<ul class="o_usermenu_list" v-if="isLoggedIn">
							<li class="o_usermenu1">
								<a href="/HFO_MP_005">내정보</a>
							</li>
							<li class="o_usermenu2">
								<a href="#" @click="logout">로그아웃</a>
							</li>
							<li class="o_usermenu3" v-if="!isKbPrmHost">
								<a href="#" @click.prevent="addKakaoChannel">채널추가</a>
							</li>
						</ul>

						<!-- 로그인 상태에 따른 메뉴 표시 - 로그인하지 않은 경우 -->
						<ul class="o_usermenu_list" v-else>
							<li class="o_usermenu1" v-if="!isKbPrmHost">
								<a href="/HFO_LO_001_POP" @click.prevent="openLoginPopup('signup')">회원가입</a>
							</li>
							<li class="o_usermenu2" v-if="!isKbPrmHost">
								<a href="/HFO_LO_001" @click.prevent="openLoginPopup('login')">로그인</a>
							</li>
							<li class="o_usermenu3" v-if="!isKbPrmHost">
								<a href="#" @click.prevent="addKakaoChannel">채널추가</a>
							</li>
						</ul>
					</div>

					<button class="btn_allmenu_close" @click="allMenu">
						전체메뉴 닫기
					</button>
				</div>
			</div>

			<button class="btn_allmenu" @click="allMenu">전체메뉴</button>
		</div>
	</header>

	<!-- 카카오 채널 추가 결과 알림 팝업 -->
	<AlertPopup v-model="showKakaoAlert" title="알림">
		<template #layer_content>
			<p class="alert_txt">
				{{ kakaoAlertMessage }}
			</p>
		</template>
	</AlertPopup>
</template>

<script>
import { siteHostname } from "@/lib/Seo";
import { profileForHost } from "@/lib/siteProfiles";
import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant";
import { isAuthenticated } from "@/lib/UserInfo";
import { useRouter } from "vue-router";
import { emitter } from '@/lib/eventBus';
import AlertPopup from "@/components/AlertPopup.vue";
import { SessionManager } from "@/lib/SessionManager";
import { getConfig, setConfig } from "@/lib/Config";

export default {
	components: {
		AlertPopup,
	},
	data() {
		const hostname = siteHostname();
		const isKbPrmHost = hostname === "kbprm.hivitamin.co.kr";
		// 카드별 H1 텍스트(로고 이미지 뒤에 숨은 텍스트). 검색엔진 차별화용.
		const siteHeading = profileForHost(hostname).heading || "하이비타민";

		return {
			isLoggedIn: isAuthenticated(), // 로그인 상태를 추적
			isKbPrmHost,
			siteHeading,
			brandPagePath: isKbPrmHost ? "/HFO_BI_001_KBPRM" : "/HFO_BI_001",
			headerClass: "header",
			// URL(href)에 'geps' 포함 시 등 은행별 로고 클래스 결정
			logoClass: this.detectLogoClass(),
			isOpen: false,
			hotKeywords: [], // 인기 검색어 배열
			topKeyword: "인기 검색어", // 기본값
			isLoading: false,
			searchBanners: [],  // 세션 저장된 배너 객체 배열
			// 카카오 채널 관련 데이터 추가
			showKakaoAlert: false,
			kakaoAlertMessage: '',
		};
	},
	created() {
		console.log("HeaderLayout created 호출됨");

		// eventBus 리스너 등록 - created에서 등록
		this.setupEventListeners();
	},
	async mounted() {
		console.log("HeaderLayout mounted 호출됨");
		window.addEventListener("resize", this.checkScreenSize);

		try {
			console.log("fetchHotKeywords 호출 시도...");
			await this.fetchHotKeywords();
			console.log("fetchHotKeywords 완료");
		} catch (error) {
			console.error("mounted 내에서 fetchHotKeywords 호출 중 오류:", error);
		}

		// 로그인 상태 추적 + URL 변경 시 로고 재평가
		this.$router.afterEach(() => {
			this.updateLoginState();
			this.handleSessionCheck();
			this.logoClass = this.detectLogoClass();
		});

		document.addEventListener('click', this.handleGlobalClick);

		// 카카오 SDK 초기화 체크
		this.initKakaoSDK();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
		document.removeEventListener('click', this.handleGlobalClick);

		// eventBus 리스너 해제
		this.removeEventListeners();
	},
	methods: {
		// 호스트(카드 프로필) 기준으로 로고 클래스 결정.
		// URL 전체(href)에서 'kb' 를 찾으면 광고·공유 링크의 추적 파라미터(gclid, NaPm 등 무작위 문자열)에 'kb' 가 섞여
		// 나라사랑카드(하나카드) 등 다른 호스트에 KB금융그룹 로고가 뜨므로 호스트만 본다. 프리렌더 중에는 주입된 운영 호스트를 쓴다.
		detectLogoClass() {
			const LOGO_BY_PROFILE = {
				kbprm: 'logo_kb_prm',
				kb: 'logo_kb',
				nhbank: 'logo_nh',
				geps: 'logo_geps',
				woori: 'logo_woori',
				samsung: 'logo_samsung',
			};
			try {
				return LOGO_BY_PROFILE[profileForHost(siteHostname()).key] || 'logo';
			} catch (e) {
				return 'logo';
			}
		},
		// eventBus 리스너 설정
		setupEventListeners() {
			console.log("HeaderLayout: eventBus 리스너 등록");

			// 로그인 상태 변경 이벤트 리스너
			emitter.on('user-login-changed', this.handleUserLoginChanged);

			// 로그아웃 상태 변경 이벤트 리스너 (필요시)
			emitter.on('user-logout', this.handleUserLogout);
		},

		// eventBus 리스너 해제
		removeEventListeners() {
			console.log("HeaderLayout: eventBus 리스너 해제");

			emitter.off('user-login-changed', this.handleUserLoginChanged);
			emitter.off('user-logout', this.handleUserLogout);
		},

		// 로그인 상태 변경 이벤트 핸들러
		handleUserLoginChanged(eventData) {
			console.log("HeaderLayout: user-login-changed 이벤트 수신:", eventData);

			if (eventData && eventData.isLoggedIn) {
				this.isLoggedIn = true;
				console.log("HeaderLayout: 로그인 상태로 변경됨");

				// 필요시 사용자 정보도 저장
				if (eventData.userInfo) {
					console.log("HeaderLayout: 사용자 정보:", eventData.userInfo);
				}
			} else {
				this.isLoggedIn = false;
				console.log("HeaderLayout: 로그아웃 상태로 변경됨");
			}

			// 강제 리렌더링 (필요시)
			this.$forceUpdate();
		},

		// 로그아웃 이벤트 핸들러
		handleUserLogout() {
			console.log("HeaderLayout: user-logout 이벤트 수신");
			this.isLoggedIn = false;
			this.$forceUpdate();
		},

		// 카카오 SDK 초기화 체크
		initKakaoSDK() {
			// 카카오 SDK가 로드되었는지 확인
			if (typeof window.Kakao !== 'undefined' && window.Kakao) {
				console.log('HeaderLayout: 카카오 SDK 로드 완료');
			} else {
				console.warn('HeaderLayout: 카카오 SDK가 로드되지 않았습니다.');
			}
		},

		// 카카오 채널 추가 메서드
		addKakaoChannel() {
			try {
				// 카카오 SDK 존재 여부 확인
				if (typeof window.Kakao === 'undefined' || !window.Kakao) {
					this.kakaoAlertMessage = '카카오 서비스를 이용할 수 없습니다.\n잠시 후 다시 시도해주세요.';
					this.showKakaoAlert = true;
					return;
				}

				// 카카오 채널 추가 API 호출
				window.Kakao.Channel.followChannel({
					channelPublicId: '_aFaen'
				});

				console.log('HeaderLayout: 카카오 채널 추가 요청 완료');

				// 전체메뉴가 열려있다면 닫기
				this.closeAllMenu();

			} catch (error) {
				console.error('HeaderLayout: 카카오 채널 추가 오류:', error);
				this.kakaoAlertMessage = '카카오 채널 추가 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.';
				this.showKakaoAlert = true;
			}
		},

		// 전체메뉴 닫기 메서드
		closeAllMenu() {
			const allmenuBtn = document.querySelector(".header");
			if (allmenuBtn && allmenuBtn.classList.contains("open")) {
				allmenuBtn.classList.remove("open");
			}
		},

		allMenu() {
			// 이벤트 버스를 통해 App.vue의 closeEvent 호출
			emitter.emit('close-notice-banner');

			// 약간의 지연 후 메뉴 토글
			setTimeout(() => {
				const allmenuBtn = document.querySelector(".header");
				if (allmenuBtn.classList.contains("open")) {
					allmenuBtn.classList.remove("open");
				} else {
					allmenuBtn.classList.add("open");
				}
			}, 50);
		},

		updateLoginState() {
			const previousState = this.isLoggedIn;
			this.isLoggedIn = isAuthenticated(); // 로그인 상태 갱신

			console.log("HeaderLayout: 로그인 상태 갱신", {
				이전상태: previousState,
				현재상태: this.isLoggedIn,
				localStorage: !!localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO)
			});

			// 상태가 변경된 경우에만 강제 업데이트
			if (previousState !== this.isLoggedIn) {
				this.$forceUpdate();
			}
		},

		logout() {
			console.log("HeaderLayout: 로그아웃 처리 시작");

			// 1. 사용자 정보와 세션 키를 함께 삭제
			SessionManager.expireSession();
			console.log("HeaderLayout: localStorage 사용자 정보와 세션 키 삭제 완료");

			// 2. hvm_config에서 platform 정보 및 user 정보 삭제
			try {
				const currentConfig = getConfig() || {};
				console.log("HeaderLayout: 현재 hvm_config", currentConfig);

				// platform 정보와 user 정보 삭제
				const updatedConfig = {
					...currentConfig,
					platform: null, // ✅ platform 정보 삭제
					user: {
						isLoggedIn: false,
						loginType: 'GUEST',
						userInType: 'GUEST',
						platformType: null,
						userId: null,
						userName: null,
						email: null,
						phone: null,
						token: null,
						refreshToken: null,
						loginDate: null,
						platformUser: null,
						platformGroup: null,
						platformSeq: null
					}
				};

				setConfig(updatedConfig);
				console.log("HeaderLayout: hvm_config 정리 완료", {
					이전Config: currentConfig,
					새Config: updatedConfig
				});

			} catch (error) {
				console.error("HeaderLayout: hvm_config 정리 중 오류", error);

				// 오류 발생 시 강제로 localStorage에서 hvm_config 삭제
				try {
					localStorage.removeItem('hvm_config');
					console.log("HeaderLayout: hvm_config 강제 삭제 완료");
				} catch (removeError) {
					console.error("HeaderLayout: hvm_config 강제 삭제 실패", removeError);
				}
			}

			// 3. 로그아웃 이벤트 발생
			emitter.emit('user-logout');
			console.log("HeaderLayout: user-logout 이벤트 발생");

			// 4. 로그인 상태 업데이트
			this.updateLoginState();
			console.log("HeaderLayout: 로그인 상태 업데이트 완료");

			// 5. 홈으로 리다이렉트
			this.$router.push("/");
			console.log("HeaderLayout: 홈으로 리다이렉트");

			// 6. 전체메뉴가 열려있다면 닫기
			this.closeAllMenu();
		},

		toggleOpen(event) {
			event.stopPropagation(); // 토글 버튼 클릭 시 이벤트 버블링 방지
			this.isOpen = !this.isOpen;
		},

		handleGlobalClick(event) {
			// ref로 검색어 영역 DOM을 가져옴
			const area = this.$refs.searchWordArea;
			if (this.isOpen && area && !area.contains(event.target)) {
				this.isOpen = false;
			}
		},

		// SessionStorage에서 검색어 배너 로드
		async fetchHotKeywords() {
			this.isLoading = true;
			try {
				const stored = sessionStorage.getItem('hvm_searchBanners');
				const banners = stored ? JSON.parse(stored) : [];
				this.searchBanners = banners;
				this.hotKeywords = banners.map(b => b.bannerTitle);
				this.topKeyword = this.hotKeywords[0] || '인기 검색어';
			} catch (e) {
				console.error('검색어 배너 로드 실패:', e);
				this.searchBanners = [];
				this.hotKeywords = [];
				this.topKeyword = '인기 검색어';
			} finally {
				this.isLoading = false;
			}
		},

		// 리스트 클릭 시 해당 키워드의 배너 객체 찾아 네비게이션
		searchByKeyword(keyword) {
			// 검색어 영역 닫기
			this.isOpen = false;

			const banner = this.searchBanners.find(b => b.bannerTitle === keyword);
			if (banner?.brandUuid) {
				sessionStorage.setItem('brandUuid', banner.brandUuid);
			}
			// 이미 BI_002 페이지라면 쿼리 추가하여 강제 갱신
			if (this.$route.path === '/HFO_BI_002') {
				this.$router.replace({
					path: '/HFO_BI_002',
					query: { _ts: Date.now() }
				});
			} else {
				this.$router.push('/HFO_BI_002');
			}
		},

		handleSessionCheck() {
			// SessionManager를 통한 세션 체크 및 갱신
			const sessionResult = SessionManager.checkAndRenewIfValid();

			if (sessionResult) {
				// 세션이 유효하고 갱신됨
				this.isLoggedIn = true;
				console.log("HeaderLayout: 로그인 상태 유지 및 세션 갱신됨");
			} else {
				// 세션 만료 또는 로그인 정보 없음
				this.isLoggedIn = false;
			}
		},

		// 제휴브랜드 링크 클릭 시 상태 초기화
		handleBrandLinkClick() {
			// 브랜드 관련 세션 스토리지 초기화
			sessionStorage.setItem('brandCurrentPage', '1');
			sessionStorage.setItem('selectedCategoryTab', '0');
			sessionStorage.setItem('selectedServiceType', '');
			sessionStorage.removeItem('brandNameInput');
			sessionStorage.removeItem('brandSelectedOptions');

			console.log('HeaderLayout: 제휴브랜드 링크 클릭 - 상태 초기화');
		},

		resolveLoginPopupMode(mode = 'login') {
			return mode === 'signup' ? 'signup' : 'login';
		},

		resolveLoginPopupHeight(mode, isDesktopPopup) {
			if (mode === 'signup' && isDesktopPopup) {
				return 690;
			}
			return 460;
		},

		resolveLoginPopupResizeHeight(mode, isDesktopPopup, popupHeight, requestedHeight, maxPopupHeight) {
			if (mode === 'signup' && isDesktopPopup) {
				const signupMinHeight = Math.min(560, maxPopupHeight);
				return Math.min(maxPopupHeight, Math.max(signupMinHeight, requestedHeight));
			}
			return Math.min(maxPopupHeight, Math.max(popupHeight, requestedHeight));
		},

		// 로그인 팝업 오픈 및 메시지 처리
		openLoginPopup(mode = 'login') {
			try {
				// 햄버거(전체메뉴) 열림 상태면 먼저 닫기
				this.closeAllMenu();
				const popupMode = this.resolveLoginPopupMode(mode);

				// 현재 접속 도메인 기준으로 팝업(POP 전용 페이지)을 엽니다
				const target = `${window.location.origin}/HFO_LO_001_POP?mode=${popupMode}`;
				//const target = 'http://192.168.50.203:8080/HFO_LO_001_POP';

				// Start with a compact initial size to avoid a large white-area flash.
				// The popup will report its ideal size and the opener will resize it shortly after open.
				const popupWidth = 380;
				const isDesktopPopup = window.innerWidth >= 1024;
				const popupHeight = this.resolveLoginPopupHeight(popupMode, isDesktopPopup);
				// Prefer centering relative to the current browser window (works better in Chrome, multi-monitor)
				const winX = typeof window.screenX === 'number' ? window.screenX : (typeof window.screenLeft === 'number' ? window.screenLeft : 0);
				const winY = typeof window.screenY === 'number' ? window.screenY : (typeof window.screenTop === 'number' ? window.screenTop : 0);
				const outerW = typeof window.outerWidth === 'number' ? window.outerWidth : window.screen.width;
				const outerH = typeof window.outerHeight === 'number' ? window.outerHeight : window.screen.height;
				const left = Math.floor(winX + Math.max(0, Math.floor((outerW - popupWidth) / 2)));
				const top = Math.floor(winY + Math.max(0, Math.floor((outerH - popupHeight) / 2)));

				// 고유 팝업 이름
				const popupName = `hvm_login_${Date.now()}`;
				const popup = window.open(target, popupName, `width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`);
				if (!popup) {
					alert('팝업이 차단되었습니다. 팝업 허용 후 다시 시도하세요.');
					return;
				}

				this.currentPopup = popup;
				this.popupId = popupName;

				console.log('openLoginPopup: popup opened', popupName, 'target:', target);
				// 메시지 핸들러
				const messageHandler = (e) => {
					console.log('openLoginPopup: message event received', e && e.data ? e.data : e);
					const origin = String(e.origin || '');
					// 허용 도메인 체크
					const allowed = origin === window.location.origin || origin.includes('localhost') || origin.includes('bridgem.hivitamin.co.kr');
					if (!allowed) return;
					const data = e.data || {};

					// Popup content size message: allow popup to suggest a new size so opener can resize & recenter it
					if (data.type === 'HVM_POPUP_CONTENT_SIZE') {
						try {
							const requestedWidth = parseInt(data.width, 10) || popupWidth;
							const requestedHeight = parseInt(data.height, 10) || popupHeight;
							const maxPopupWidth = Math.min(560, Math.max(420, (window.screen?.availWidth || outerW) - 24));
							const maxPopupHeight = Math.min(980, Math.max(560, (window.screen?.availHeight || outerH) - 24));
							const newWidth = Math.min(maxPopupWidth, Math.max(320, requestedWidth));
							const newHeight = this.resolveLoginPopupResizeHeight(
								popupMode,
								isDesktopPopup,
								popupHeight,
								requestedHeight,
								maxPopupHeight
							);
							// Resize popup if possible
							if (this.currentPopup && !this.currentPopup.closed && typeof this.currentPopup.resizeTo === 'function') {
								try {
									this.currentPopup.resizeTo(newWidth, newHeight);
								} catch (resizeErr) { console.warn('popup resizeTo failed', resizeErr); }
							}
							// Re-center relative to current browser window
							try {
								const centerLeft = Math.floor(winX + Math.max(0, Math.floor((outerW - newWidth) / 2)));
								const centerTop = Math.floor(winY + Math.max(0, Math.floor((outerH - newHeight) / 2)));
								if (this.currentPopup && !this.currentPopup.closed && typeof this.currentPopup.moveTo === 'function') {
									try { this.currentPopup.moveTo(centerLeft, centerTop); } catch (moveErr) { console.warn('popup moveTo failed', moveErr); }
								}
							} catch (centerErr) { console.warn('popup recenter failed', centerErr); }
							return;
						} catch (e) { console.warn('HVM_POPUP_CONTENT_SIZE handling error', e); }
					}
					if (data.type === 'HVM_LOGIN_COMPLETED') {
						// 저장
						console.log('openLoginPopup: HVM_LOGIN_COMPLETED received', data);
						if (data.user) localStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(data.user));
						if (data.token) sessionStorage.setItem('hvm_token', data.token);
						this.updateLoginState();
						try { SessionManager.startSession(); } catch (e) { console.warn(e); }
						// ACK 전송
						try {
							if (e.source && typeof e.source.postMessage === 'function') {
								e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
							} else if (this.currentPopup && !this.currentPopup.closed) {
								this.currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
							} else {
								console.warn('ACK: no e.source and no currentPopup to post ACK');
							}
						} catch (ackErr) { console.warn('ACK failed', ackErr); try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this.popupId }, e.origin); } catch (_) { console.warn('Fallback close request failed'); } }
						// 닫기
						setTimeout(() => { try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (err) { console.warn('popup close error', err); } this.currentPopup = null; this.popupId = null; }, 100);
						emitter.emit('user-login-changed', { isLoggedIn: true, userInfo: data.user || null });
					} else if (data.type === 'HVM_LOGIN_NEED_SIGNUP') {
						if (data.userData) sessionStorage.setItem('signup_user_data', JSON.stringify(data.userData));
						try {
							if (e.source && typeof e.source.postMessage === 'function') {
								e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
							} else if (this.currentPopup && !this.currentPopup.closed) {
								this.currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
							} else {
								console.warn('ACK: no e.source and no currentPopup to post ACK');
							}
						} catch (ackErr) { console.warn('ACK failed', ackErr); try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this.popupId }, e.origin); } catch (_) { console.warn('Fallback close request failed'); } }
						setTimeout(() => {
							try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (err) { console.warn('popup close error', err); }
							this.currentPopup = null;
							this.popupId = null;
							const userData = data.userData || {};
							const isKakaoUser = (userData.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
							this.$router.push(isKakaoUser ? '/HFO_MB_004_SNS' : '/HFO_MB_003');
						}, 100);
					} else if (data.type === 'HVM_POPUP_CLOSE_REQUEST') {
						try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (err) { console.warn('popup close error', err); } this.currentPopup = null; this.popupId = null;
					}
				};

				window.addEventListener('message', messageHandler, false);
				// 타임아웃으로 자동 정리
				setTimeout(() => { window.removeEventListener('message', messageHandler); }, 10 * 60 * 1000);
			} catch (err) {
				console.error('openLoginPopup error', err);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/* PC 버전 스타일 (1024px 이상) */
@media (min-width: 1024px) {

	/* cont_center에 relative 포지션 설정 */
	.cont_center {
		position: relative !important;
	}

	/* 기존 스타일 유지 */
	.top_menu {
		position: absolute !important;
		top: 50% !important;
		/* 수직 중앙 정렬 */
		transform: translateY(-50%) !important;
		/* 수직 중앙 정렬 */
		right: toRem(44) !important;
		/* 전체메뉴 버튼과의 간격 확보 */
		min-width: auto !important;
		width: auto !important;
		justify-content: flex-end !important;
		gap: toRem(14) !important;
		z-index: 100 !important;
		display: flex !important;
		align-items: center !important;
		height: toRem(65) !important;

		li {
			margin-left: toRem(15);
			height: 100%;
			display: flex;
			align-items: center;

			a {
				padding: toRem(0) toRem(10);
				height: 100%;
				display: flex;
				align-items: center;
				white-space: nowrap !important;
			}
		}
	}

	/* 전체 메뉴 버튼을 cont_center 맨 오른쪽 중앙으로 정렬 */
	.btn_allmenu {
		position: absolute !important;
		top: 50% !important;
		/* 수직 중앙 정렬 */
		transform: translateY(-50%) !important;
		/* 수직 중앙 정렬 */
		right: 0 !important;
		/* cont_center 기준 맨 오른쪽 */
		width: toRem(40) !important;
		height: toRem(65) !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		z-index: 90 !important;
		background-position: center !important;
		margin: 0 !important;
		/* 기본 마진 제거 */
	}

	/* GNB 리스트 여백 추가 */
	.gnb_list {
		margin-right: toRem(280) !important;
		padding-right: toRem(20);
	}
}

/* 모바일 버전 스타일 (1023px 이하) - 기존 스타일 유지 */
@media (max-width: 1023px) {
	.top_menu {
		position: absolute;
		top: 0;
		/* 모바일은 기존 위치 유지 */
		right: toRem(60);
		transform: none;
		z-index: 100;
		display: flex;
		height: toRem(60);
		align-items: center;
	}

	/* 모바일에서도 전체 메뉴 버튼 위치 조정 */
	.btn_allmenu {
		position: absolute;
		top: 0;
		/* 모바일은 기존 위치 유지 */
		right: toRem(0);
		margin-right: 0;
		z-index: 90;
		height: toRem(60);
		display: flex;
		align-items: center;
	}
}

/* 카카오 채널 추가 버튼 호버 효과 */
.o_usermenu_list li a {
	transition: opacity 0.3s ease;
}

.o_usermenu_list li a:hover {
	opacity: 0.8;
}

/* 알림 팝업 스타일 커스터마이징 (필요시) */
:deep(.alert_txt) {
	white-space: pre-line;
	/* 줄바꿈 문자 인식 */
}

/* 헤더 배경 이미지 설정 */
.header {
	height: toRem(65);
	background-color: #ffffff;
	position: relative;
	z-index: 20;
}

/* add optional override to prevent header image */
.header {
	background-image: none !important;
}

.kbprm-header.open {
	&::before {
		display: none;
	}

	.menu_layout {
		border-color: #ffe39a;
		height: toRem(130) !important;
	}

	.menu_area {
		margin-top: toRem(36) !important;
	}

	.gnb_list2_area {
		margin-left: auto;
	}

	.btn_allmenu_close {
		display: block;
		z-index: 101;
	}

	.btn_allmenu_close,
	.gnb_list>li>a::before,
	.gnb_list2 a::before,
	.o_usermenu_list a::before {
		filter: sepia(1) saturate(0.55) brightness(1.55);
	}

	.o_usermenu_list a {
		color: #7a5b00;
	}
}

@media (max-width: 1023px) {
	.kbprm-header.open {
		.o_usermenu_list {
			background-color: #ffe39a;

			li::before {
				background-color: #f1cd72;
			}
		}
	}
}
</style>
